// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import CompanyAssetsTab from '../../components/Company/CompanyAssets/CompanyAssetsTab';
import DisplayBox from '../../ui-elements/DisplayBox/DisplayBox';
import Label from '../../ui-elements/Label/Label';
// Type imports:
import { ICompanyViewModel } from '../../types/CompanyTypes';

const CompanyVehiclesPage: React.FC<ICompanyViewModel> = ({
    id,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id} 
                title='Ökutæki'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                component={
                    <DisplayBox
                        title='Ökutæki'
                        asideComponent={<Label text='ÖKUT.SKR.' fullText="Ökutækjaskrá" labelType='origin' />}
                    >
                        <CompanyAssetsTab
                            large
                            assetType='vehicles'
                            id={id}
                            isAuthenticated={isAuthenticated}
                        />
                    </DisplayBox>
                } 
            />
        </Entrypoint>
    );
}

export default CompanyVehiclesPage;